import React from 'react';

import './index.scss';

export default function ProfileImage({imageUrl, sourceUrl}) {
    return (
        <a href={sourceUrl} target="_blank" rel="noopener noreferrer">
            <div className="profile-image" style={{backgroundImage: `url(${imageUrl})`}} />
        </a>
    );
}



// WEBPACK FOOTER //
// ./components/profile_image/index.js